
/** A regular expression that validates that a string contains only a single valid email */
// eslint-disable-next-line max-len
export const validEmailRegex: RegExp = /^(?:[a-z0-9!#$%*'&+/_=?^{|}~-]+(?:\.[a-z0-9!#$%*'&+/=_?^{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;

/** A regular expression used in separating a string into multiple emails */
export const emailSeparatorsRegex: RegExp = /,|;/g;

/**
 * Validates that a string represents a correctly formatted single email
 */
export function validateEmail(email: string): boolean {
    if (!email) {
        return false;
    }

    const emailAddress = email.trim();

    if (emailAddress.indexOf(' ') > 0) {
        return false;
    }

    const localPart = emailAddress.split('@')[0];
    if (localPart.length > 64) {
        return false;
    }

    return validEmailRegex.test(emailAddress);
}

/**
 * Validates a string of multiple emails is correctly formatted
 */
export function validateEmails(email: string): boolean {
    if (!email) {
        return false;
    }

    const emails = email.split(emailSeparatorsRegex).filter(x => !!x);

    for (let i = 0; i < emails.length; i++) {
        if (!validateEmail(emails[i])) {
            return false;
        }
    }

    return true;
}

export function extractEmails(emailString: string): string[] {
    let tokens = emailString.split(emailSeparatorsRegex);

    if (tokens.length === 1) {
        // Single e-mail
        if (tokens[0].indexOf(' ') === -1) {
            return tokens;
        } else {
            // Space  was the seaparator.. trickier here because names can contain spaces that aren't separators
            // Note that if a string is pasted into the input with linebreaks they will become spaces, so this
            // covers that.
            if (tokens[0].indexOf('<') === -1) {
                // santosh.patel@agilitypr.com john.lawrance@agilitypr.com
                return tokens[0].split(' ')
                    .map(x => x.trim())
                    .filter(x => x.length > 0);
            }

            // Santosh Patel <santosh.patel@agilitypr.com> John Lawrance <john.lawrance@agilitypr.com>
            tokens = tokens[0].split('>');
            return tokens
                .filter(token => token.trim().length > 0) // there's always a blank one at the end
                .map(token => {
                    const nameAndEmail = token.split('<');
                    // TODO : Leverage this name
                    const name =  nameAndEmail[0].trim();
                    return nameAndEmail[1].trim();
                });
        }
    }

    // ; or , was the separator
    return tokens
        .filter(token => token.trim().length > 0)
        .map(token => {

            // Santosh Patel <santosh.patel@agilitypr.com>; John Lawrance <john.lawrance@agilitypr.com>;
            if (token.indexOf('<') >= 0) {
                const nameAndEmail = token.split('<');
                // TODO : Leverage this name
                const name =  nameAndEmail[0].trim();
                return nameAndEmail[1].trim().replace('>', '');
            } else {
                // santosh.patel@agilitypr.com, john.lawrance@agilitypr.com
                // santosh.patel@agilitypr.com; john.lawrance@agilitypr.com
                return token.trim();
            }
        });
}
